//import adotbackground from '../images/adotlogo.png';
import adotbackground from '../images/Secondary_transparent.png';
import delasoftlogo from '../images/DelasoftLogoNew.png';
import oregonlogo from '../images/odoticon.png';
import kytclogo from '../images/kytcicon.jpg';
import adotavatar from '../images/adotavatar.png';
import wisconsin from '../images/wisconsin.png';
import DeldotLogo from '../images/deldot.png';
import Laoacsimage from '../images/Laoacs.jpg';
import { getEnvVariable } from '../../../../modules/environmentalList';

export const getLandingPagelogo = (open = true) => {
    let right = (localStorage.getItem('internaltoken') || localStorage.getItem('externaltoken')) ? RightDrawerAvatar() : false
    let key = getEnvVariable('ModuleKey')
    switch (key) {
        case 'KEPT':
            return kytclogo
        case 'AMES':
            return oregonlogo
        case 'MPS':
            return delasoftlogo
        case 'AEPS':
            return (right && open) ? adotbackground : !open ? adotavatar : adotbackground
        case 'WRS':
            return wisconsin
        case 'UPS':
            return DeldotLogo
        case 'LAOACS':
            return Laoacsimage
        default: return adotbackground
    }
}


export const RightDrawerAvatar = () => {
    let key = getEnvVariable('ModuleKey')
    switch (key) {
        case 'AEPS':
        case 'WRS':
            return true
        default: return false
    }
}

//Condition for Hiding Modules for External
export const hideForSubmodules = (key) => {
    switch (key) {
        case 'STATEPROJECTS':
            return true
        case 'VIOLATIONS':
            return true
        case 'JUNKYARDS':
            return true
        case 'TRANSFER':
            return true
        default: return false
    }
}